import axios from 'axios';
import { getLocale } from '../services/locale.service';

// ------------------
// NOTE! APP_URL and API_URL sets in main blade file by backend
// ------------------

const createAxiosInstance = (baseURL) => {
    let token = document.head.querySelector('meta[name="csrf-token"]');

    return axios.create({
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
            common: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': token.content
            }
        }
    });
}

const appendXLocaleToHeader = (config) => {
    const locale = getLocale(); // sessionStorage.getItem('pr_locale');
    if (locale) {
        config.headers['X-Locale'] = locale;
    }
    return config;
}

const httpApi = createAxiosInstance(API_URL);
const httpApiv2 = createAxiosInstance(API_V2_URL);

httpApi.interceptors.request.use(
    appendXLocaleToHeader,
    error => {
        return Promise.reject(error);
    }
);
httpApiv2.interceptors.request.use(
    appendXLocaleToHeader,
    error => {
        return Promise.reject(error);
    }
);

httpApi.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // todo: hämta CSRF token igen - https://medium.com/@serhii.matrunchyk/laravel-vue-spas-how-to-send-ajax-requests-and-not-run-into-csrf-tokens-mismatch-exceptions-da3b71b287ab

        if (error.response && error.response.status === 419) { // 401) {
            window.location = '/';
        }
        return Promise.reject(error);
    }
);


// const http = axios.create({
//     baseURL: APP_URL,
//     headers: {
//         'Content-Type': 'application/json',
//         common: {
//             'X-Requested-With': 'XMLHttpRequest',
//             'X-CSRF-TOKEN': token.content
//         }
//     }
// });

const httpGet = (url) => httpApiv2.get(url).then(response => response.data);

export default httpApi;
export { httpApiv2, httpGet };
// export { http };